/**
 * @param {string} rfcDateTime - example 2020-05-16T13:00:00.000+03:00
 * @returns {string} Wednesday, 2 June
 */
export function rfcToShiftedDate(rfcTimeString) {
    const rfcSeparators = /[-T:.+]/;
    const [year, month, day, hour, minutes, seconds, millis] = rfcTimeString
        .split(rfcSeparators)
        .map((dateComponentString) => parseInt(dateComponentString, 10));
    return new Date(year || 0, month - 1 || 0, day || 0, hour || 0, minutes || 0, seconds || 0, millis || 0);
}
/**
 * @param {Date} date
 * @returns {string} an rfc string representing the given date's local time, will add a Z (which makes it shifted so don't use it - only if you know why you do so)
 * example: new Date('2020-05-16T13:00:00.000+02:00') => 2020-05-16T13:00:00.000Z (these 2 don't represent the same time, thus - shifted)
 */
export function dateToShiftedRfcString(date) {
    const addZeroIfNeeded = (dateComponent, digits = 2) => {
        const stringValue = dateComponent.toString();
        const zeros = stringValue.length < digits
            ? new Array(digits - stringValue.length).fill(0)
            : [];
        return zeros.join('') + stringValue;
    };
    const year = date.getFullYear();
    const month = addZeroIfNeeded(date.getMonth() + 1);
    const day = addZeroIfNeeded(date.getDate());
    const hour = addZeroIfNeeded(date.getHours());
    const minute = addZeroIfNeeded(date.getMinutes());
    const second = addZeroIfNeeded(date.getSeconds());
    const miliseconds = addZeroIfNeeded(date.getMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${miliseconds}Z`;
}
//# sourceMappingURL=dateTimeAdapter.js.map